/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import widgetWrapper from './widgetWrapper';
import './ErrorChangeWidget.scss';

class NewRelicErrorChangeWidget extends Component {

  static propTypes = {
    title: PropTypes.string,
    count: PropTypes.string
  };

  static defaultProps = {
    title: '',
    count: ''
  };

  constructor(...args) {
    super(...args);
    this.chartRef = React.createRef();
  }

  render() {
    // Apply some default formatting.
    const {
      title = '',
      count = ''
    } = this.props;

    return (
      <div className={`widget-threshold-colors ErrorChangeWidget`}>
        <div className="header">
          <div className="policy">{title}</div>
          <br></br>
          <div className="count">{count}</div>
        </div>
      </div>
    );
  }
}
export default widgetWrapper(NewRelicErrorChangeWidget);
